import HTTP from 'owp.http';
import { getMonthsInbetween } from './commonTest';


// Helper function to fetch JSONP data
async function fetchData(url: string, params: any): Promise<any> {
	const headers: Record<string, string> = { Origin: 'https://app.vantetider.se/spa/1.1/rest' };
	const response = await HTTP.jsonp(url, { headers, params });
	return response;
}


// Function to fetch data for tables and some graphs

export async function fetchTrendData(url: string, params: any, seriesObjectName: string): Promise<any> {
	return new Promise((resolve, reject) => {
		fetchData(url, params)
			.then((res: any) => {
				if (res[seriesObjectName] && res[seriesObjectName].length > 0)
					resolve(res);
				else
					reject("No " + seriesObjectName);
			})
			.catch(reject);
	})
}


// Function to format different types of data for filters mainly

export async function formatData(params: any, url: string): Promise<any> {
	return new Promise((resolve, reject) => {
		fetchData(url, params)
			.then(res => {
				const transformedData = transformDates(res);
				const formattedData = addNameAndValueProperties(transformedData);
				resolve(formattedData);
			})
			.catch(reject);
	});
}

export const addNameAndValueProperties = (obj: any): any => {
	if (obj === null || typeof obj !== "object") {
		return obj;
	}
	const newObj: any = Array.isArray(obj) ? [] : {};
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const newKey = key.toLowerCase().endsWith('name') ? 'name' : key.toLowerCase().endsWith('id') && !key.endsWith('_ids') ? 'value' : key;
			newObj[newKey] = addNameAndValueProperties(obj[key]);
		}
	}
	return newObj;
};

const getMonthsRange = (startMonth: string, endMonth: string, isNationell = false) => {
	if (isNationell) {
		return startMonth === endMonth ? [startMonth] : [startMonth, endMonth];
	}

	return getMonthsInbetween("Januari", endMonth);
};

export const handleDateKey = (key: string, value: any): any => {
	const isNationell = key === "datesNationell";
	const years = Array.from(
		{ length: value.endYear - value.startYear + 1 },
		(_, i) => i + Number(value.startYear));
	const months = getMonthsRange(value.startMonth, value.endMonth, isNationell);

	return {
		years,
		months,
		'startMonth': value.startMonth,
		'endMonth': value.endMonth,
		'startYear': value.startYear,
		'endYear': value.endYear
	};
};

export const transformDates = (res: any) => {
	for (const key in res) {
		if (res.hasOwnProperty(key) && ["dates", "datesNew", "datesNationell", "datesSomatic", "datesPsychiatric"].includes(key)) {
			res[key] = handleDateKey(key, res[key]);
		}
	}
	return res;
}